export const isDevEnv = process.env.NODE_ENV === 'development';
export const ENV_STORAGE = isDevEnv ? process.env : window;

export const REACT_APP_RSD_DOMAIN = ENV_STORAGE.REACT_APP_RSD_DOMAIN || process.env.REACT_APP_RSD_DOMAIN;

export const REACT_APP_DAO_DOMAIN = ENV_STORAGE.REACT_APP_RSD_DOMAIN || process.env.REACT_APP_RSD_DOMAIN;

export const REACT_APP_AUTH_CUBES_JWT_KEY = process.env.REACT_APP_AUTH_CUBES_JWT_KEY;
export const REACT_APP_AUTH_CUBES_JWT_ISSUER = process.env.REACT_APP_AUTH_CUBES_JWT_ISSUER;
export const REACT_APP_AUTH_CUBES_JWT_AUDIENCE = process.env.REACT_APP_AUTH_CUBES_JWT_AUDIENCE;
